import { render } from "./ArchiveDescription.vue?vue&type=template&id=30af32c6&ts=true"
import script from "./ArchiveDescription.vue?vue&type=script&lang=ts"
export * from "./ArchiveDescription.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__